import { Link } from 'react-router-dom';
import './UI.css';

// ─── BUTTON ───────────────────────────────────────────────────────────────────
export function Button({ children, variant = 'primary', size = 'md', to, href, onClick, className = '', ...props }) {
  const cls = `btn btn--${variant} btn--${size} ${className}`;
  if (to)   return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} onClick={onClick} {...props}>{children}</button>;
}

// ─── SERVICE CARD ─────────────────────────────────────────────────────────────
export function ServiceCard({ service, onInquire }) {
  const colorMap = { saffron: 'card--saffron', teal: 'card--teal', gold: 'card--gold', navy: 'card--navy' };
  return (
    <div className={`service-card ${colorMap[service.color] || ''}`}>
      <div className="service-card__icon">{service.icon}</div>
      <div className="service-card__cat">{service.cat.charAt(0).toUpperCase() + service.cat.slice(1)}</div>
      <h3 className="service-card__title">{service.title}</h3>
      <p className="service-card__desc">{service.short}</p>
      <div className="service-card__footer">
        {service.features && service.features.slice(0, 2).map(f => (
          <span key={f} className="service-card__tag">{f}</span>
        ))}
        <button className="service-card__btn" onClick={() => onInquire && onInquire(service.title)}>
          Inquire <span>→</span>
        </button>
      </div>
    </div>
  );
}

// ─── SECTION HEADER ───────────────────────────────────────────────────────────
export function SectionHeader({ badge, badgeVariant = 'saffron', title, subtitle, align = 'center', dark = false }) {
  return (
    <div className={`section-header section-header--${align} ${dark ? 'section-header--dark' : ''}`}>
      {badge && <span className={`section-badge badge-${badgeVariant}`}>{badge}</span>}
      <h2 className="section-header__title">{title}</h2>
      {subtitle && <p className="section-header__sub">{subtitle}</p>}
    </div>
  );
}

// ─── PAGE HERO ────────────────────────────────────────────────────────────────
export function PageHero({ badge, title, highlight, subtitle, children }) {
  return (
    <section className="page-hero">
      <div className="page-hero__bg" />
      <div className="page-hero__deco" />
      <div className="container page-hero__inner">
        <div className="page-hero__content animate-fade-up">
          {badge && <span className="section-badge badge-white">{badge}</span>}
          <h1 className="page-hero__title">
            {title}{highlight && <><br /><span className="page-hero__highlight">{highlight}</span></>}
          </h1>
          {subtitle && <p className="page-hero__sub">{subtitle}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}

// ─── STAT CARD ────────────────────────────────────────────────────────────────
export function StatCard({ num, label, dark = false }) {
  return (
    <div className={`stat-card ${dark ? 'stat-card--dark' : ''}`}>
      <div className="stat-card__num">{num}</div>
      <div className="stat-card__label">{label}</div>
    </div>
  );
}

// ─── TESTIMONIAL CARD ─────────────────────────────────────────────────────────
export function TestimonialCard({ testimonial }) {
  return (
    <div className="testimonial-card">
      <div className="testimonial-card__stars">
        {'★'.repeat(testimonial.rating)}
      </div>
      <p className="testimonial-card__text">"{testimonial.text}"</p>
      <div className="testimonial-card__author">
        <div className="testimonial-card__avatar">
          {testimonial.flag}
        </div>
        <div>
          <div className="testimonial-card__name">{testimonial.name}</div>
          <div className="testimonial-card__meta">{testimonial.role} · {testimonial.country}</div>
        </div>
      </div>
    </div>
  );
}

// ─── FEATURE ITEM ─────────────────────────────────────────────────────────────
export function FeatureItem({ icon, title, desc }) {
  return (
    <div className="feature-item">
      <div className="feature-item__icon">{icon}</div>
      <div>
        <h4 className="feature-item__title">{title}</h4>
        <p className="feature-item__desc">{desc}</p>
      </div>
    </div>
  );
}

// ─── INQUIRY CTA BANNER ───────────────────────────────────────────────────
export function CTABanner({ title, sub }) {
  return (
    <section className="cta-banner">
      <div className="container cta-banner__inner">
        <div className="cta-banner__text">
          <h2 className="cta-banner__title">{title}</h2>
          <p className="cta-banner__sub">{sub}</p>
        </div>
        <div className="cta-banner__actions">
          <Button to="/contact" variant="white">Send an Inquiry</Button>
          <Button href="tel:+919967765284" variant="outline-white">Call Us: +91 9967 765284</Button>
        </div>
      </div>
    </section>
  );
}
